import React, { FC, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import YouTubePlayer, { YouTubeProps } from 'react-youtube';

import type { ReduxState } from 'app/redux/types';

import { selectLiveStreamPreferences } from 'app/modules/LiveStream/selectors';

import styles from '../../LiveStream.module.scss';

const YOUTUBE_PLAYER_OPTIONS: YouTubeProps['opts'] = {
  playerVars: {
    controls: 0,        // disable controls
    rel: 0,             // do not show related video
    fs: 0,              // hide fullscreen button
    showinfo: 0,        // do not show video info on start
    autoplay: 1,        // enable autoplay
    disablekb: 1,       // disable keyboard controls
    iv_load_policy: 3,  // hide video annotation
    modestbranding: 1,  // hide YouTube second logo
  },
};

type YouTubeHandlerProps = {
  videoId: string;
} & ReturnType<typeof mapStateToProps>;

type InternalPlayer = ReturnType<YouTubePlayer['getInternalPlayer']>;

const YouTubeHandler: FC<YouTubeHandlerProps> = ({
  videoId,
  muted,
}) => {
  const [player, setPlayer] = useState<InternalPlayer>(null);

  useEffect(() => {
    if (YOUTUBE_PLAYER_OPTIONS.playerVars) {
      YOUTUBE_PLAYER_OPTIONS.playerVars.mute = muted ? 1 : 0; // initial mute state, 1 - mute, 0 - unMute
    }
  }, []);

  useEffect(() => {
    if (player) {
      player[muted ? 'mute' : 'unMute']();
    }
  }, [muted]);

  const handlePlayerReady = useCallback((event: { target: InternalPlayer }) => {
    setPlayer(event.target);
  }, []);

  return (
    <div className={styles.youTubeContainer}>
      <YouTubePlayer videoId={videoId}
                     onReady={handlePlayerReady}
                     opts={YOUTUBE_PLAYER_OPTIONS} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  muted: selectLiveStreamPreferences(state).muted,
});

export default connect(mapStateToProps)(YouTubeHandler);
